import React from 'react';
import PropTypes, {
  arrayOf,
  bool,
  string,
  shape,
  func,
} from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { handleMktAnalytics, updateLinksWithOriginB2B } from '../../AmexMarketingUtils/AmexUtils';
import AmexGDAFeaturedCard from './AmexGDAFeaturedCard';
import { setGDAEventsHideStatus } from '../../../../../../ui-kitchen/src/reducers/amexEventsSlice';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';

import './AmexGDAFeatured.scss';

const AmexGDAFeatured = ({
  featured, restaurants, printContent, hasOriginB2B, hideEvents,
  dispatch, Analytics,
}) => {
  const {
    heading, ctaText, bookNowLinkText, noBookNowText,
  } = { ...featured };

  const handleLinkClick = () => {
    const extraParam = {
      action_name: 'Featured Restaurants - Program Restaurants Click',
    };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
    dispatch(setGDAEventsHideStatus(hideEvents));
  };
  return (
    <div className="GDA__Featured__Wrap">
      <h2>{printContent(heading, 'heading')}</h2>
      <div className="GDA__Featured__Wrap__Grid">
        {restaurants.map((restaurant) => (
          <AmexGDAFeaturedCard
            key={`${restaurant.name}${restaurant.cuisine}`}
            restaurant={restaurant}
            bookNowLinkText={printContent(bookNowLinkText, 'bookNowLinkText')}
            noBookNowText={printContent(noBookNowText, 'noBookNowText')}
            Analytics={Analytics}
          />
        ))}
      </div>
      <Link
        className="GDA__Featured--CTA"
        href={updateLinksWithOriginB2B('/global-dining-access/directory', hasOriginB2B)}
        onContextMenu={() => handleLinkClick()}
        onClick={() => handleLinkClick()}
      >
        {printContent(ctaText, 'ctaText')}
      </Link>
    </div>
  );
};

AmexGDAFeatured.defaultProps = {
  featured: {
    heading: '',
    ctaText: '',
    bookNowLinkText: '',
    noBookNowText: '',
  },
  restaurants: [],
};

AmexGDAFeatured.propTypes = {
  featured: shape({
    heading: string,
    ctaText: string,
    bookNowLinkText: string,
    noBookNowText: string,
  }),
  restaurants: arrayOf(shape({})),
  printContent: func.isRequired,
  hasOriginB2B: bool.isRequired,
  hideEvents: bool.isRequired,
  dispatch: func.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexGDAFeatured;
